import { BackendQueryKeys, useTypeSafeQuery } from '@oresundsbron/api';
import { useEffect, useState } from 'react';
import {
  authenticate,
  getAuthToken,
  resetAuthentication,
} from '../stores/auth';
import { useUser } from '@auth0/nextjs-auth0/client';
import { useRouter } from 'next/router';
import { CustomerType } from '@oresundsbron/validators';

export function useIsAuthenticated() {
  const [state, setState] = useState({ loading: true, authenticated: false });
  const [accessToken, setAccessToken] = useState<string | null>(getAuthToken());
  const [isAccessTokenFetched, setIsAccessTokenFetched] =
    useState<boolean>(false);
  const [isAccessTokenLoading, setIsAccessTokenLoading] =
    useState<boolean>(false);

  const { refetch, data } = useTypeSafeQuery(
    BackendQueryKeys.CustomerInformation(),
    ({ Customer }) => Customer.get,
    { enabled: false }
  );
  const router = useRouter();
  const { user, isLoading } = useUser();

  useEffect(() => {
    const fetchToken = async () => {
      if (isAccessTokenLoading) return;
      setIsAccessTokenLoading(true);
      const accessTokenResponse = await fetch('/api/auth/access-token');
      if (!accessTokenResponse.ok) {
        resetAuthentication();
        const locale = router.locale;
        router.replace(`/api/auth/login?locale=${locale}`);
        return;
      }
      setAccessToken(await accessTokenResponse.json());
      setIsAccessTokenFetched(true);
    };

    if (data && accessToken) {
      authenticate(accessToken, data.customerType, '', false);
      setState({ authenticated: true, loading: false });
      return;
    }

    if (isLoading) return;

    if (!user) {
      resetAuthentication();
      const locale = router.locale;
      router.replace(`/api/auth/login?locale=${locale}`);
      return;
    }

    fetchToken();

    if (accessToken) {
      // Set temporary customer type to privateCustomer
      authenticate(accessToken, CustomerType.privateCustomer, '', false);
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, router, user, isAccessTokenFetched, refetch]);

  return state;
}
